// External modules
import { action } from 'easy-peasy';

// Internal modules
import { logger } from '@/lib/logger';
import { apiModelFactory, getApiState } from './api/api';
import { formModelFactory, getFormState } from './form';
import { getUiState, uiModelFactory } from './ui';
import { getUserState, userModelFactory } from './user/user';
import type { GenericObjectType } from '@/types';
import type { UserModel } from './user';

type getInitialStoreStateParam =
  | {
      api?: GenericObjectType;
      form?: GenericObjectType;
      ui?: GenericObjectType;
      user?: UserModel;
    }
  | undefined;

const getInitialStoreState = ({
  api,
  form,
  ui,
  user,
}: getInitialStoreStateParam = {}) => ({
  api: getApiState(api),
  form: getFormState(form),
  ui: getUiState(ui),
  user: getUserState(user),
});

export const storeModel = {
  api: apiModelFactory(),
  form: formModelFactory(),
  ui: uiModelFactory(),
  user: userModelFactory(),

  // This probably doesn't need to be an action, which is causing the
  // odd typing due to action, but not touching prod code in TS conversion PR
  // eslint-disable-next-line sort-keys
  resetStore: action((_, overrides: getInitialStoreStateParam) => {
    logger.info('reset_app_store');
    return getInitialStoreState(overrides);
  }),
};

export type StoreModelType = typeof storeModel;
export * from './utils';
export * from './types';
